import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import _ from 'lodash';
import * as actions from '../../../../actions/response';
import { useDispatch } from 'react-redux';
import { PURCHASE_CONFIRMATION_START } from 'actions/payway';

const ModalGtres = props => {
  const dispatch = useDispatch();
  const { title, queryParams, onClose, callback } = props;
  let str = '';
  _.forEach(queryParams, (value, key) => {
    str += `&${key}=${encodeURIComponent(value)}`;
  });
  const height = { height: '400px' };
  const onMessage = ({ data }) => {
    if (data && typeof data === 'string' && JSON.parse(data)) {
      const message = JSON.parse(data);
      if (message && message.key) {
        dispatch(actions.removeModal());
        callback(message);
      }
    }
  };
  useEffect(() => {
    dispatch({ type: PURCHASE_CONFIRMATION_START });
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return (
    <Modal show>
      <Modal.Header>
        <Button
          className="close close-modal"
          onClick={() => {
            onClose();
            dispatch(actions.removeModal());
          }}
        >
          x
        </Button>
        <h2 className="modal-title">{title}</h2>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <div className="col-md-12" style={height}>
          <iframe
            src={`/gtres?${str}`}
            width={`100%`}
            height={`100%`}
            frameBorder={'0'}
            scrolling={'no'}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalGtres;
